module.exports = __webpack_public_path__ + "img/v2.a913d281.png";